import { useBlockedAction, paywallActionNoun, showDailyLimitPaywall } from "@/hooks/usePaywallDialog";

/**
 * Stays on the tool page after the paywall was dismissed, so a blocked action never looks like a broken tool
 * (blank output, nothing listed). It names the blocked action and says the person's input is kept. No prices here:
 * the paywall dialog and the strip's buttons own those.
 */
export function TrialBlockedNote({ toolId }: { toolId: string | undefined }) {
  const action = useBlockedAction(toolId);
  if (!action) return null;
  return (
    <p role="status" data-testid="trial-blocked-note" className="mt-2 text-sm text-muted-foreground">
      Today's trial uses are used up, so {paywallActionNoun(action)} was not done. Your input is still here and nothing was lost. Trial uses start fresh tomorrow, or{" "}
      <button type="button" className="underline underline-offset-2 hover:text-foreground" onClick={() => showDailyLimitPaywall(toolId, action)}>
        see the pass options
      </button>
      .
    </p>
  );
}
